import React from 'react';

function Info() {
    return (
        <div className="px-5 py-5 text-white">
            <h2>
            Picnic 2024 registration closed, due to unavilibility of seat.
            If you have any question, please contact Amra-Amra <a href="https://amra-amra.se/contacts">(Contacts)</a>.
            </h2>
        </div>
    )
}
export default Info;